import axios from 'axios';

let baseUrl = "http://api.confirmame.site";

if(document.domain == 'pruebas.confirma.me'){
    baseUrl = "https://apipruebas.confirma.me/";
}

if(document.domain == 'testing.confirma.me'){
    baseUrl = "https://apitesting.confirma.me/";
}

if(document.domain == 'confirmame.inwork.site'){
    baseUrl = "https://apiconfirmame.inwork.site";
}

if(document.domain == 'confirma.me' || document.domain == 'app.confirma.me'){
    baseUrl = "https://api.confirma.me";
}

axios.defaults.baseURL = baseUrl;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'Application/json';

if (localStorage.getItem('domain') === null || localStorage.getItem('domain') === 'undefined') {
    axios.defaults.headers.common['domain'] = 'demo';
} else {
    axios.defaults.headers.common['domain'] = localStorage.getItem('domain');
}

if (localStorage.getItem('token') === null || localStorage.getItem('token') === 'undefined') {
    axios.defaults.headers.common['api-token'] = '';
} else {
    axios.defaults.headers.common['api-token'] = localStorage.getItem('token');
}

axios.interceptors.request.use(function (config) { 
    return config;
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    if(error.response !== undefined){
        if (error.response.status === 503) {
            const currentHash = ((window && window.location && window.location.hash) ? window.location.hash : '').toLowerCase();

            if (currentHash.indexOf('#/emergency/resume') === 0) {
                return Promise.reject(error);
            }

            localStorage.removeItem('token');
            axios.defaults.headers.common['api-token'] = '';

            if (window.location.hash !== '#/maintenance') {
                window.location.hash = '/maintenance';
            }

            return Promise.reject(error);
        } else if (error.response.status === 401) {
            console.log(error.response);
        } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 400) {
            throw error;
        } else {
            return Promise.reject(error);
        }
    }
    else{
        return Promise.reject(error);
    }
})
